import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(theme => ({
  card: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#fff',
    borderRadius: 7,
    boxShadow: '0 2px 4px 0 rgba(0,0,0,0.5)',
    padding: '10px 10px',
    cursor: 'pointer',
    marginBottom: 20,
    textDecoration: 'none',
    color: '#1F2D3D',
    minHeight: 130,
    transition: 'all 0.3s ease-in-out',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column'
    },
    '&:hover': {
      boxShadow: '0 3px 4px 0 rgba(0,0,0,0.5)',
      transform: 'translateY(-2px)'
    }
  },
  avatar: {
    width: 56,
    height: 56,
    display: 'flex',
    overflow: 'hidden',
    position: 'relative',
    fontSize: '1.25rem',
    alignItems: 'center',
    flexShrink: 0,
    lineHeight: 1,
    userSelect: 'none',
    borderRadius: '50%',
    justifyContent: 'center',
    '& > img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      backgroundColor: '#cdcdcd'
    },
    [theme.breakpoints.down('md')]: {
      marginBottom: 20
    }
  },
  talentName: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#1F2D3D'
  },
  talentData: {
    fontSize: '14px',
    color: '#1F2D3D'
  },
  tagContainer: {
    width: '42%',
    marginLeft: 'auto',
    display: 'flex',
    flexWrap: 'wrap',
    [theme.breakpoints.down('md')]: {
      marginTop: 20,
      width: 'unset',
      marginLeft: 'unset'
    }
  },
  tag: {
    border: '1px solid #979797',
    borderRadius: 8,
    margin: 3,
    padding: '2px 2px',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      margin: '3px 0'
    }
  },
  tagValue: {
    color: '#000A12',
    fontSize: '11px',
    padding: '0 3px'
  },
  initiativeQuestionsContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginTop: 10
  },
  initiativeQuestionsBtn: {
    padding: '4px 20px',
    fontSize: 13
  }
}))
